// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';



export class U128 implements flatbuffers.IUnpackableObject<U128T> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):U128 {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsU128(bb:flatbuffers.ByteBuffer, obj?:U128):U128 {
  return (obj || new U128()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsU128(bb:flatbuffers.ByteBuffer, obj?:U128):U128 {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new U128()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

upper():bigint {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint64(this.bb_pos + offset) : BigInt('0');
}

lower():bigint {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint64(this.bb_pos + offset) : BigInt('0');
}

static startU128(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addUpper(builder:flatbuffers.Builder, upper:bigint) {
  builder.addFieldInt64(0, upper, BigInt('0'));
}

static addLower(builder:flatbuffers.Builder, lower:bigint) {
  builder.addFieldInt64(1, lower, BigInt('0'));
}

static endU128(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static finishU128Buffer(builder:flatbuffers.Builder, offset:flatbuffers.Offset) {
  builder.finish(offset);
}

static finishSizePrefixedU128Buffer(builder:flatbuffers.Builder, offset:flatbuffers.Offset) {
  builder.finish(offset, undefined, true);
}

static createU128(builder:flatbuffers.Builder, upper:bigint, lower:bigint):flatbuffers.Offset {
  U128.startU128(builder);
  U128.addUpper(builder, upper);
  U128.addLower(builder, lower);
  return U128.endU128(builder);
}

unpack(): U128T {
  return new U128T(
    this.upper(),
    this.lower()
  );
}


unpackTo(_o: U128T): void {
  _o.upper = this.upper();
  _o.lower = this.lower();
}
}

export class U128T implements flatbuffers.IGeneratedObject {
constructor(
  public upper: bigint = BigInt('0'),
  public lower: bigint = BigInt('0')
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return U128.createU128(builder,
    this.upper,
    this.lower
  );
}
}
